<div class="login-failed-container">
  <div class="login-failed-content">
    <h1 class="login-failed-heading">Login failed</h1>
    <p class="login-failed-message">Sorry, looks like your login failed. Please try signing in again.</p>
    
    <div class="login-failed-actions">
      <lds-button 
        [isDisabled]="isRetrying"
        (onClick)="retry()"
        appearance="primary">
        {{ isRetrying ? 'Retrying...' : 'Try Again' }}
      </lds-button>
    </div>
  </div>
</div>